import React, { useState, useEffect, useContext, useReducer } from 'react'

import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tooltip,
    Button,
    TextField,
    Divider,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    List,
    ListItem,
    IconButton,
    Switch,
    Alert
} from '@mui/material'

import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/Help';

import api from '../../../api';

import useNotification from '../../Notification';
import defaultReducer from '../../../utils/defaultReducer';
import IntegerOnly from '../../../utils/IntegerOnly';
import MultipleSelections from '../../Input/MultipleSelections';
import VariableTextField from '../../Input/VariableTextField';

import { getSession } from '../../../auth';

import './styles.css'

const action = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const treatnumber = (number) => {
    if (number.length > 0 && number[0] === '+')
        return number
    return `+${number}`
}

const checkButtonText = (state) => {
    const text = []

    if (!state.nick)
        text.push(<Box>Digite o número.</Box>)

    if (text.length == 0)
        return ''

    return (text)
}

const submit = async (data, allRows, setParentState) => {
    const enterpriseId = getSession().profile.enterprise.id
    const payload = data
    const method = data.id ? 'PATCH' : 'POST'

    if (!payload)
        return

    setParentState({ loading: true })

    let response

    if (method === 'POST')
        response = await api.post(`api/enterprises/${enterpriseId}/nongrata/`, payload)
    else
        response = await api.patch(`api/enterprises/${enterpriseId}/nongrata/${data.id}/`, payload)

    if (response.status !== 201 && response.status !== 200) {
        setParentState({ loading: false })
        if (response.status === 400) {
            // Add 400 errors messages here
            useNotification(
                'Ops!',
                'Esse número já foi cadastrado.',
                'warning'
            )

            return
        }
        useNotification(
            'Ops!',
            'Houve um problema com a sua requisição, contate um administrador.',
            'warning'
        )
        return
    }

    if (method === 'POST') {
        useNotification(
            'Sucesso!',
            'Número bloqueado.',
            'success'
        )

        setParentState({
            rows: [...allRows, response.data],
            edit: null,
            loading: false
        })
        return
    }

    useNotification(
        'Sucesso!',
        'Seus números bloqueados foram atualizados com sucesso.',
        'success'
    )

    const updatedRows = [...allRows]
    updatedRows.forEach((value, key) => {
        if (value.id == response.data['id'])
            updatedRows[key] = response.data
    })

    setParentState({
        rows: updatedRows,
        edit: null,
        loading: false
    })
}

const EditNonGrata = ({ data, allRows, setParentState, handleClose }) => {

    const [state, setState] = useReducer(defaultReducer, {
        nick: '',
    })

    return (
        <>
            <Dialog open={true}
                fullWidth
                disablePortal
                disableEnforceFocus
                sx={{ position: 'absolute' }}
                maxWidth={'xs'}
            >
                <DialogTitle id="customized-dialog-title" className={'group-flexbox'}>
                    {action(data)} contato bloqueado
                    <Button onClick={() => window.open("https://instant.getoutline.com/s/canal-do-cliente/doc/configurando-jornadas-de-atendimento-RzL8hS97Nb", "_blank")}>FAQ</Button>
                    {/* TODO */}
                </DialogTitle>
                <Divider />
                <DialogContent className='piloto-modal-flex'>
                    <Box className="category-title">
                        Número
                    </Box>
                    <TextField
                        fullWidth
                        size="small"
                        label="Número"
                        type="text"
                        variant="outlined"
                        value={state.nick}
                        onChange={(event) => setState({ nick: event.target.value })}
                    />
                </DialogContent>
                <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
                    <Button onClick={() => setParentState({ edit: null })}>
                        Cancelar
                    </Button>
                    <Tooltip title={checkButtonText(state)} placement="top" describeChild={true}>
                        <span>
                            <Button
                                disabled={checkButtonText(state)}
                                onClick={() => submit(state, allRows, setParentState)}>
                                Salvar
                            </Button>
                        </span>
                    </Tooltip>
                </DialogActions>
            </Dialog >
        </>
    )
}

export default EditNonGrata
